module.exports = __webpack_public_path__ + "img/nms-demo2.aa3c758f.png";